import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ArrowRight } from "lucide-react";
import '../../App.css';

import legeMagistrati from '../../assets/lege-magistrati.png';
import digitalPentruBine from '../../assets/digital-pentru-bine.png';
import plamanulVerde from '../../assets/plamanul-verde.jpeg';
import united from '../../assets/united.png';

const projects = [
  {
    category: "Digitalizare",
    img: digitalPentruBine,
    title: "Digital pentru bine",
    desc: "Un ecosistem digital care conectează ONG-urile din România cu resursele și tehnologia de care au nevoie pentru a crea un impact real în comunități.",
    link: "/digital-pentru-bine"
  },
  {
    category: "Mediu",
    img: plamanulVerde,
    title: "Plămânul Verde al Orașului",
    desc: "Transformăm spațiile urbane abandonate în parcuri și grădini comunitare, aducând mai multă natură în viața de zi cu zi a românilor.",
    link: "/plamanul-verde-al-orasului"
  },
  {
    category: "Diaspora",
    img: united,
    title: "U-nite-D – România Globală",
    desc: "Reconectăm diaspora cu România prin programe de mentorat, investiții comunitare și oportunități profesionale de impact.",
    link: "/united-romania-globala"
  },
];

export default function ProiecteSection() {
  return (
    <section className="projects-section py-5">
      <Container className="py-4">
        
        {/* Header-ul secțiunii */}
        <div className="text-center mb-5">
          <h2 className="section-title">
            Proiectele noastre pentru România
          </h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            Fiecare proiect este gândit să aducă schimbări concrete în viața românilor
          </p>
        </div>

        {/* Grila de carduri */}
        <Row className="g-4">
          {projects.map((proj, idx) => (
            <Col key={idx} md={6} lg={4}>
              <div className="project-card h-100 d-flex flex-column">
                
                {/* Imaginea cardului */}
                <div className="card-image-wrapper">
                  <img
                    src={proj.img}
                    alt={proj.title}
                    className="card-img"
                  />
                </div>
                
                {/* Conținutul cardului */}
                <div className="card-content d-flex flex-column flex-grow-1">
                  
                  {/* Badge-ul de Categorie */}
                  <div className="mb-3">
                    <span className="category-badge">{proj.category}</span>
                  </div>
                  
                  {/* Titlu și Descriere */}
                  <h4 className="card-title mb-3">{proj.title}</h4>
                  <p className="card-desc mb-4 flex-grow-1">{proj.desc}</p>
                  
                  {/* Butonul minimalist cu săgeată */}
                  <div className="mt-auto">
                    <a href={proj.link} className="btn-card-link">
                      Vezi detalii 
                      <ArrowRight size={18} className="ms-2 btn-arrow" />
                    </a>
                  </div>

                </div>
              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
}
